module.exports = __webpack_public_path__ + "static/img/wechat.1473f5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wechat.png
// module id = zuiJ
// module chunks = 1